import { RecoilState, useRecoilState, useResetRecoilState } from 'recoil';
import { subDays } from 'date-fns';
import { DateRangeType } from 'enums';

const defaultEndDate = new Date();
defaultEndDate.setHours(0, 0, 0, 0);
const defaultStartDate = subDays(defaultEndDate, 92);

export type DateFilterState = {
    dateRange: DateRangeType
};

export const DefaultDateFilter = {
    dateRange: DateRangeType.ThreeMonths
};

export const useDateFilter = (atom: RecoilState<any>) => {
    const [state, setState] = useRecoilState(atom);
    const reset = useResetRecoilState(atom);

    const setField = (field: string, value?: any) => {
        setState((current: any) => ({
            ...current,
            [field]: value
        }));
    };

    const setDateRange = (value: DateRangeType) => setField('dateRange', value);

    return {
        ...state,
        setField,
        setDateRange,
        reset
    };
};
